import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section id="categorias" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 text-xs font-medium text-accent-600 bg-accent-50 rounded-full mb-4 whitespace-nowrap">
            Navegue por Categoria
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-2">
            Encontre os Melhores Produtos
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            por Categoria em 2026 — clique para acessar no kaspreadsheet.com
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-100 hover:bg-primary-50 rounded-xl overflow-hidden transition-all duration-200 cursor-pointer flex flex-col"
            >
              <div className="relative h-36 md:h-40 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={cat.namePt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100/80 via-transparent to-transparent group-hover:from-primary-50/80 transition-colors duration-200"></div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <div className="flex items-center gap-2.5 mb-2">
                  <div className="w-8 h-8 rounded-lg bg-background-200 flex items-center justify-center group-hover:bg-primary-100 transition-colors flex-shrink-0">
                    <i className={`${cat.icon} text-sm text-foreground-600 group-hover:text-primary-500 transition-colors`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors">
                    {cat.namePt}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 flex-1">
                  {cat.description}
                </p>
                <span className="flex items-center gap-1.5 text-xs font-medium text-primary-500 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  Explorar
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}